const parentFolder = 'animation/pe/a1/'
export default  {
  v: '5.9.0',
  fr: 29.9700012207031,
  ip: 0,
  op: 387.000015762833,
  w: 850,
  h: 700,
  nm: 'Animación-premio-Home',
  ddd: 0,
  assets: [
    { id: 'image_0', w: 542, h: 274, u: parentFolder, p: 'img_0.png', e: 0 },
    { id: 'image_1', w: 610, h: 188, u: parentFolder, p: 'img_1.png', e: 0 },
    { id: 'image_2', w: 301, h: 307, u: parentFolder, p: 'img_2.png', e: 0 },
    { id: 'image_3', w: 610, h: 188, u: parentFolder, p: 'img_3.png', e: 0 },
    { id: 'image_4', w: 486, h: 250, u: parentFolder, p: 'img_4.png', e: 0 },
    { id: 'image_5', w: 610, h: 188, u: parentFolder, p: 'img_5.png', e: 0 },
    { id: 'image_6', w: 610, h: 188, u: parentFolder, p: 'img_6.png', e: 0 },
    { id: 'image_7', w: 280, h: 290, u: parentFolder, p: 'img_7.png', e: 0 },
    { id: 'image_8', w: 914, h: 758, u: parentFolder, p: 'img_8.png', e: 0 },
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 2,
      nm: 'Group 45046.png',
      cl: 'png',
      refId: 'image_0',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [440, 398, 0], ix: 2, l: 2 },
        a: { a: 0, k: [271, 137, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.335, 0.335, 0.667], y: [1, 1, 1] },
              o: { x: [0.704, 0.704, 0.333], y: [0, 0, 0] },
              t: 284,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.384, 0.384, 0.667], y: [1, 1, 1] },
              o: { x: [0.648, 0.648, 0.333], y: [0, 0, 0] },
              t: 301,
              s: [110, 110, 100],
            },
            {
              i: { x: [0.569, 0.569, 0.667], y: [1, 1, 1] },
              o: { x: [0.442, 0.442, 0.333], y: [0, 0, 0] },
              t: 321,
              s: [100, 100, 100],
            },
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [1, 1, 0.333], y: [0, 0, 0] },
              t: 379,
              s: [100, 100, 100],
            },
            { t: 387.000015762833, s: [0, 0, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 284.000011567557,
      op: 1785.00007270454,
      st: 284.000011567557,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 2,
      nm: 'Group 45050.png',
      cl: 'png',
      refId: 'image_1',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [446, 190, 0], ix: 2, l: 2 },
        a: { a: 0, k: [305, 94, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.335, 0.335, 0.667], y: [1, 1, 1] },
              o: { x: [0.704, 0.704, 0.333], y: [0, 0, 0] },
              t: 284,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.384, 0.384, 0.667], y: [1, 1, 1] },
              o: { x: [0.648, 0.648, 0.333], y: [0, 0, 0] },
              t: 301,
              s: [110, 110, 100],
            },
            {
              i: { x: [0.569, 0.569, 0.667], y: [1, 1, 1] },
              o: { x: [0.442, 0.442, 0.333], y: [0, 0, 0] },
              t: 321,
              s: [100, 100, 100],
            },
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [1, 1, 0.333], y: [0, 0, 0] },
              t: 379,
              s: [100, 100, 100],
            },
            { t: 387.000015762833, s: [0, 0, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 284.000011567557,
      op: 1785.00007270454,
      st: 284.000011567557,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 2,
      nm: 'Group 45032.png',
      cl: 'png',
      refId: 'image_2',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [425, 408, 0], ix: 2, l: 2 },
        a: { a: 0, k: [150.5, 153.5, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.335, 0.335, 0.667], y: [1, 1, 1] },
              o: { x: [0.704, 0.704, 0.333], y: [0, 0, 0] },
              t: 189,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.384, 0.384, 0.667], y: [1, 1, 1] },
              o: { x: [0.648, 0.648, 0.333], y: [0, 0, 0] },
              t: 206,
              s: [110, 110, 100],
            },
            {
              i: { x: [0.569, 0.569, 0.667], y: [1, 1, 1] },
              o: { x: [0.442, 0.442, 0.333], y: [0, 0, 0] },
              t: 226,
              s: [100, 100, 100],
            },
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [1, 1, 0.333], y: [0, 0, 0] },
              t: 284,
              s: [100, 100, 100],
            },
            { t: 292.000011893404, s: [0, 0, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 189.000007698128,
      op: 1690.00006883511,
      st: 189.000007698128,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 4,
      ty: 2,
      nm: 'Group 45049.png',
      cl: 'png',
      refId: 'image_3',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [442, 190, 0], ix: 2, l: 2 },
        a: { a: 0, k: [305, 94, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.335, 0.335, 0.667], y: [1, 1, 1] },
              o: { x: [0.704, 0.704, 0.333], y: [0, 0, 0] },
              t: 189,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.384, 0.384, 0.667], y: [1, 1, 1] },
              o: { x: [0.648, 0.648, 0.333], y: [0, 0, 0] },
              t: 206,
              s: [110, 110, 100],
            },
            {
              i: { x: [0.569, 0.569, 0.667], y: [1, 1, 1] },
              o: { x: [0.442, 0.442, 0.333], y: [0, 0, 0] },
              t: 226,
              s: [100, 100, 100],
            },
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [1, 1, 0.333], y: [0, 0, 0] },
              t: 284,
              s: [100, 100, 100],
            },
            { t: 292.000011893404, s: [0, 0, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 189.000007698128,
      op: 1690.00006883511,
      st: 189.000007698128,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 5,
      ty: 2,
      nm: 'Mask Group 40991.png',
      cl: 'png',
      refId: 'image_4',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [406, 460, 0], ix: 2, l: 2 },
        a: { a: 0, k: [243, 125, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.335, 0.335, 0.667], y: [1, 1, 1] },
              o: { x: [0.704, 0.704, 0.333], y: [0, 0, 0] },
              t: 94,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.384, 0.384, 0.667], y: [1, 1, 1] },
              o: { x: [0.648, 0.648, 0.333], y: [0, 0, 0] },
              t: 111,
              s: [110, 110, 100],
            },
            {
              i: { x: [0.569, 0.569, 0.667], y: [1, 1, 1] },
              o: { x: [0.442, 0.442, 0.333], y: [0, 0, 0] },
              t: 131,
              s: [100, 100, 100],
            },
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [1, 1, 0.333], y: [0, 0, 0] },
              t: 189,
              s: [100, 100, 100],
            },
            { t: 197.000008023974, s: [0, 0, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 94.0000038286985,
      op: 1595.00006496568,
      st: 94.0000038286985,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 6,
      ty: 2,
      nm: 'Group 45065.png',
      cl: 'png',
      refId: 'image_5',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [440, 190, 0], ix: 2, l: 2 },
        a: { a: 0, k: [305, 94, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.335, 0.335, 0.667], y: [1, 1, 1] },
              o: { x: [0.704, 0.704, 0.333], y: [0, 0, 0] },
              t: 94,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.384, 0.384, 0.667], y: [1, 1, 1] },
              o: { x: [0.648, 0.648, 0.333], y: [0, 0, 0] },
              t: 111,
              s: [110, 110, 100],
            },
            {
              i: { x: [0.569, 0.569, 0.667], y: [1, 1, 1] },
              o: { x: [0.442, 0.442, 0.333], y: [0, 0, 0] },
              t: 131,
              s: [100, 100, 100],
            },
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [1, 1, 0.333], y: [0, 0, 0] },
              t: 189,
              s: [100, 100, 100],
            },
            { t: 197.000008023974, s: [0, 0, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 94.0000038286985,
      op: 1595.00006496568,
      st: 94.0000038286985,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 7,
      ty: 2,
      nm: 'Group 45064.png',
      cl: 'png',
      refId: 'image_6',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [440, 190, 0], ix: 2, l: 2 },
        a: { a: 0, k: [305, 94, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.335, 0.335, 0.667], y: [1, 1, 1] },
              o: { x: [0.704, 0.704, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.384, 0.384, 0.667], y: [1, 1, 1] },
              o: { x: [0.648, 0.648, 0.333], y: [0, 0, 0] },
              t: 17,
              s: [110, 110, 100],
            },
            {
              i: { x: [0.569, 0.569, 0.667], y: [1, 1, 1] },
              o: { x: [0.442, 0.442, 0.333], y: [0, 0, 0] },
              t: 37,
              s: [100, 100, 100],
            },
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [1, 1, 0.333], y: [0, 0, 0] },
              t: 95,
              s: [100, 100, 100],
            },
            { t: 103.000004195276, s: [0, 0, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 1501.00006113698,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 8,
      ty: 2,
      nm: 'Mask Group 40990.png',
      cl: 'png',
      refId: 'image_7',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [425, 394, 0], ix: 2, l: 2 },
        a: { a: 0, k: [140, 145, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.335, 0.335, 0.667], y: [1, 1, 1] },
              o: { x: [0.704, 0.704, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.384, 0.384, 0.667], y: [1, 1, 1] },
              o: { x: [0.648, 0.648, 0.333], y: [0, 0, 0] },
              t: 17,
              s: [110, 110, 100],
            },
            {
              i: { x: [0.569, 0.569, 0.667], y: [1, 1, 1] },
              o: { x: [0.442, 0.442, 0.333], y: [0, 0, 0] },
              t: 37,
              s: [100, 100, 100],
            },
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [1, 1, 0.333], y: [0, 0, 0] },
              t: 95,
              s: [100, 100, 100],
            },
            { t: 103.000004195276, s: [0, 0, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 1501.00006113698,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 9,
      ty: 2,
      nm: 'Base premios',
      refId: 'image_8',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [437, 334, 0], ix: 2, l: 2 },
        a: { a: 0, k: [457, 379, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 1501.00006113698,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
}

